import $ from 'jquery';

if( $( '.signup-form.slider' ).length ) {
  let signUpForm = document.querySelector( '.signup-form' );
  let navCounter = document.querySelector( '.form-nav .counter span' )
  let iteration = 1
  let emptyCheck = true
  let nextArrow = $( '.form-arrow.next' )
  let prevArrow = $( '.form-arrow.prev' )

  function changeSlides() {
    $( navCounter ).text( `0${ iteration }` )
    $( '.slide' ).addClass( 'hide' )
    $( `.slide-${ iteration }` ).removeClass( 'hide' )
  }

  function validateEmail( email ) {
    const reg = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
    let result = reg.test( email.value );

    if ( result ) {
      $( email ).parent().removeClass( 'invalid invalid-email' )
      emptyCheck = false
    } else {
      emptyCheck = true
      $( email ).parent().addClass( 'invalid invalid-email' )
    }
  }

  function checkInput() {
    let slideInputs = document.querySelectorAll( `.slide-${ iteration } input[required]` )

    slideInputs.forEach( ( elem ) => {
      let inputParent = $( elem ).parent();
      console.log( $( elem ).attr( 'type' ) == 'email' );

      if( $( elem ).attr( 'type' ) == 'email' ) {
        validateEmail( elem );
      } else if( elem.value === '' ) {
        emptyCheck = true
        inputParent.addClass( 'invalid invalid-input' )
        return
      } else {
        inputParent.removeClass( 'invalid invalid-input'  )
        emptyCheck = false
      }
    } )
  }

  function formForward() {
    iteration ++
    changeSlides();
  }

  function formBack() {
    iteration = iteration - 1
    changeSlides();
  }

  nextArrow.on( 'click', function() {
    checkInput();

    if( iteration == 3 && !emptyCheck ) {
      nextArrow.addClass( 'hide' )
      formForward()
    } else if( iteration == 1 && !emptyCheck ){
      prevArrow.removeClass( 'hide' )
      formForward()
    }
      else if( iteration < 4 && !emptyCheck ) {
      formForward()
    }
  } )

  prevArrow.on( 'click', () => {
    if( iteration == 4 ) {
      nextArrow.removeClass( 'hide' )
      formBack()
    } else if ( iteration == 2 ) {
      prevArrow.addClass( 'hide' )
      formBack()
    } else if ( iteration > 1 ) {
      formBack()
    }
  } )
}